export const bookingsMetaOSStaticFeedbackText = "r7FdOc";
export default {bookingsMetaOSStaticFeedbackText};